const common = {
  "nav.home": "Home",
  "nav.services": "Servizi",
  "nav.about": "Chi Siamo",
  "nav.pricing": "Prezzi",
  "nav.testimonials": "Recensioni",
  "nav.booking": "Appuntamento",
  "nav.gallery": "Galleria",
  "nav.team": "Team",
  "nav.contact": "Contatti",

  "hero.title_line1": "La Tua Bellezza.",
  "hero.title_line2": "La Nostra Arte.",
  "hero.subtitle": "Odontoiatria premium in un'atmosfera lussuosa. Esperti di fama internazionale per il tuo nuovo sorriso – fino al 70% in meno rispetto a Germania/Austria/Svizzera.",
  "hero.cta": "Prenota un Appuntamento",
  "hero.badge": "CLINICA PREMIUM TIRANA · FINO AL 70% PIU’ ECONOMICO CHE IN DE/AT/CH",
  "hero.stat1.value": "7.500+",
  "hero.stat1.label": "Pazienti",
  "hero.stat2.value": "15",
  "hero.stat2.label": "Anni di Esperienza",
  "hero.stat3.value": "98%",
  "hero.stat3.label": "Soddisfazione",

  "services.tag": "I NOSTRI SERVIZI",
  "services.heading": "Eccellenza in Ogni Trattamento",
  "services.dental.title": "Odontoiatria",
  "services.dental.desc": "Impianti dentali, faccette, corone in zirconio, sbiancamento e altro. Protesi premium con diagnostica 3D all'avanguardia – fino al 70% in meno.",
  "services.dental.count": "12 Trattamenti",
  "services.surgery.title": "Chirurgia Plastica",
  "services.surgery.desc": "Lifting viso, rinoplastica, aumento del seno, liposuzione e altro. Massimi standard di sicurezza con hotel e transfer inclusi.",
  "services.surgery.count": "21 Interventi",
  "services.hair.title": "Trapianto di Capelli",
  "services.hair.desc": "Trapianto di capelli FUE con tecnica di micropuntura avanzata. Fino a 5.000 innesti – senza cicatrici, risultato naturalmente folto. Analisi capelli gratuita inclusa.",
  "services.hair.count": "1 Trattamento",
  "services.cta": "Scopri Tutti i Servizi",

  "about.tag": "CASA NOSTRA",
  "about.heading_line1": "Bellezza, nata in",
  "about.heading_line2": "Albania.",
  "about.description": "Nel cuore di Tirana, la vibrante capitale dell'Albania, Esteva Clinic è nata da una visione: unire l'estetica di livello mondiale al calore dell'ospitalità mediterranea. L'Albania — un paese di straordinaria bellezza, dalle acque turchesi dell'Adriatico alle maestose vette delle Alpi Albanesi — sta vivendo una spettacolare rinascita. Mentre il paese cresce rapidamente diventando una delle mete più ambite d'Europa, abbiamo creato a Tirana un luogo dove l'eccellenza medica internazionale incontra la sensazione autentica di essere veramente benvenuti. La nostra clinica riflette lo spirito dell'Albania: giovane, ambiziosa, piena di cuore — e pronta a conquistare il mondo.",
  "about.quote": "L'Albania mi ha insegnato che la vera bellezza nasce dall'autenticità. Qui, tra montagne e mare, cresciamo insieme — il paese, il nostro team e ogni persona che varca la nostra porta.",
  "about.name": "Dr. Nertila Basha",
  "about.position": "CEO, Dentista, Implantologa & Protesista",

  "pricing.tag": "PACCHETTI PREZZI",
  "pricing.heading_line1": "Eccellenza",
  "pricing.heading_line2": "Trasparente.",
  "pricing.subtitle": "Ogni pacchetto su misura per le tue esigenze. Nessun costo nascosto, nessun compromesso.",
  "pricing.basic.title": "Essential",
  "pricing.basic.price": "da 1.490 €",
  "pricing.basic.feature1": "Prima consulenza e analisi",
  "pricing.basic.feature2": "1 trattamento a scelta",
  "pricing.basic.feature3": "Pacchetto post-trattamento Basic",
  "pricing.premium.title": "Premium",
  "pricing.premium.price": "da 3.990 €",
  "pricing.premium.feature1": "Consulenza VIP",
  "pricing.premium.feature2": "2 trattamenti combinati",
  "pricing.premium.feature3": "Post-trattamento Premium e prodotti",
  "pricing.luxe.title": "Luxe",
  "pricing.luxe.price": "da 7.490 €",
  "pricing.luxe.feature1": "Concierge di bellezza personale",
  "pricing.luxe.feature2": "3 trattamenti + pacchetto hotel",
  "pricing.luxe.feature3": "1 anno di assistenza e garanzia",
  "pricing.exclusive.title": "Exclusif",
  "pricing.exclusive.price": "Personalizzato",
  "pricing.exclusive.feature1": "Trasformazione completa",
  "pricing.exclusive.feature2": "Tutti i trattamenti inclusi",
  "pricing.exclusive.feature3": "Assistenza a vita",
  "pricing.dental_title": "LISTA PREZZI DENTALI",
  "pricing.surgery_title": "LISTA PREZZI CHIRURGIA PLASTICA",
  "pricing.hair_title": "LISTA PREZZI TRAPIANTO CAPELLI",
  "pricing.included_title": "Servizi Inclusi",
  "pricing.included_over_3000": "Per preventivi superiori a 3.000 €: hotel, taxi, biglietto aereo e scansione 3D della bocca inclusi.",
  "pricing.included_over_1500": "Per preventivi superiori a 1.500 €: hotel, taxi e scansione 3D della bocca inclusi.",
  "pricing.table_service": "SERVIZIO",
  "pricing.table_price": "PREZZO (EUR)",
  "pricing.table_stay": "SOGGIORNO OSPEDALE & HOTEL",
  "pricing.table_total": "TOTALE",
  "pricing.note_individual": "I prezzi individuali possono variare in base alla complessità dell'intervento. Un preventivo dettagliato verrà fornito durante la consulenza.",
  "pricing.cta": "Prenota una Consulenza",
  "instagram.tag": "SEGUICI",
  "instagram.heading": "Scorci di Eccellenza.",
  "instagram.subtitle": "Unisciti a noi su Instagram per approfondimenti esclusivi, momenti prima-e-dopo e le ultime tendenze della medicina estetica.",
  "instagram.cta": "Segui @estevaclinic",

  "testimonials.tag": "TESTIMONIANZE",
  "testimonials.heading": "Cosa Dicono i Nostri Clienti",
  "testimonial1.text": "Sono volato da Monaco apposta — e onestamente, la decisione migliore della mia vita. Sono passati 8 mesi dalla rinoplastica e il risultato è incredibilmente naturale. La Dottoressa Krasniqi non mi ha promesso nulla che non potesse mantenere, ed è questo che mi ha convinto. La clinica è all'avanguardia, il team parla perfettamente italiano e l'assistenza post-operatoria è stata fenomenale. Nemmeno un rimpianto.",
  "testimonial1.name": "Markus W.",
  "testimonial1.role": "Rinoplastica, Monaco di Baviera",
  "testimonial2.text": "Volevo le faccette dentali da anni ma i prezzi in Svizzera erano assurdi. Un'amica mi ha consigliato Esteva Clinic e ho pensato: perché no? La differenza è — e non esagero — come se mi avessero costruito una bocca completamente nuova. 12 faccette, perfettamente simmetriche, per niente artificiali. Il mio dentista a casa è rimasto senza parole. E poi Tirana è una città meravigliosa, ne ho approfittato per una mini-vacanza.",
  "testimonial2.name": "Sophie L.",
  "testimonial2.role": "Cosmetica Dentale, Zurigo",
  "testimonial3.text": "Avevo molto rispetto per il lifting viso — tutte quelle storie di volti a maschera. Ma la Dottoressa Krasniqi mi ha spiegato tutto con calma e mi ha mostrato la tecnica SMAS. Il risultato? I miei lineamenti sono tonificati, ma sembro me stesso — solo 10 anni più giovane. Nessuno si accorge che ho fatto qualcosa — però tutti mi dicono: 'Che riposato che sei!' Esattamente quello che volevo. Naturale, niente faccia da maschera.",
  "testimonial3.name": "Chiara R.",
  "testimonial3.role": "Lifting Viso, Milano",
  "testimonial4.text": "Ho lottato con i miei denti per 15 anni. Corone, ponti, provvisori — tutta roba inutile. A 43 anni sono arrivato al punto in cui mi sono detto: adesso lo faccio sul serio. 8 impianti dentali, 2 sedute, a malapena dolore. Oggi, 10 mesi dopo, mangio e rido per la prima volta da anni senza pensarci. Il momento in cui mia figlia ha detto 'Papà, il tuo sorriso è completamente diverso' — è valso ogni centesimo.",
  "testimonial4.name": "Alexander K.",
  "testimonial4.role": "Impianti Dentali, Amburgo",
  "testimonial5.text": "Sono venuta per l'aumento del seno, sono rimasta per l'esperienza completa. Prima la chirurgia, poi il team mi ha convinta a fare anche le corone in zirconio. Hanno questo sguardo d'insieme — capiscono come tutto si armonizza. Non ti senti una paziente, ti senti un'ospite. Dal primo minuto. E il caffè a Tirana è imbattibile.",
  "testimonial5.name": "Isabella M.",
  "testimonial5.role": "Trasformazione Completa, Vienna",
  "testimonial6.text": "Il rapporto qualità-prezzo è eccellente, nessun dubbio. Le mie nuove corone in zirconio sono perfette e il team è stato molto gentile. Unico neo: la comunicazione prima dell'arrivo poteva essere più chiara — ho dovuto sollecitare due volte per i documenti. Ma sul posto tutto è filato liscio. 4 corone, 2 giorni, risultato ottimo. Ci tornerei comunque.",
  "testimonial6.name": "Thomas G.",
  "testimonial6.role": "Corone in Zirconio, Berlino",
  "testimonial7.text": "Sono andato a marzo per un trapianto di capelli FUE (3.200 innesti). L'intervento è stato professionale, il team si è preso cura di me. Dopo 5 mesi si vede già una crescita evidente, ma il risultato finale ovviamente deve ancora arrivare. Aspetto con ansia il 12° mese. La clinica è moderna, Tirana è una città splendida. Volo e hotel inclusi — tutto perfetto.",
  "testimonial7.name": "David R.",
  "testimonial7.role": "Trapianto Capelli, Francoforte",
  "testimonial8.text": "Sono andata per una piccola rinoplastica — l'intervento è andato bene e sono soddisfatta del risultato. Però i primi giorni dopo l'operazione sono stati più duri del previsto, avrei voluto essere preparata meglio. Ma l'assistenza post-operatoria è stata eccellente, il team si è davvero impegnato. Dopo 6 mesi, tutto è guarito perfettamente.",
  "testimonial8.name": "Laura B.",
  "testimonial8.role": "Rinoplastica, Stoccarda",

  "testimonials.verified": "Verificato",
  "testimonials.time_ago_months": "{{count}} mesi fa",
  "testimonials.time_ago_months_one": "1 mese fa",
  "testimonials.time_ago_years": "{{count}} anno fa",
  "testimonials.time_ago_years_plural": "{{count}} anni fa",
  "testimonials.filter_all": "Tutti",
  "testimonials.filter_dental": "Odontoiatria",
  "testimonials.filter_surgery": "Chirurgia",
  "testimonials.filter_hair": "Trapianto capelli",
  "testimonials.hero_tag": "ESPERIENZE REALI",
  "testimonials.rating_breakdown": "Distribuzione valutazioni",
  "testimonials.based_on": "Basato su {{count}} recensioni verificate",
  "testimonials.total_rating": "Valutazione Complessiva",
  "testimonials.empty_title": "Nessuna recensione in questa categoria",
  "testimonials.empty_subtitle": "Consulta un'altra categoria o sfoglia tutte le recensioni.",

  "booking.tag": "PRENOTAZIONE",
  "booking.heading_line1": "Il tuo viaggio inizia",
  "booking.heading_line2": "con una conversazione.",
  "booking.description": "Prenota ora la tua consulenza personale. I nostri esperti si prendono tempo per i tuoi desideri individuali e creano un concetto di trattamento su misura – discreto e confidenziale.",
  "booking.cta": "Prenota Appuntamento",
  "booking.hero_subtitle": "Scegli la data e l'ora che preferisci. Il nostro team ti risponderà entro 24 ore con una conferma.",
  "booking.select_date_hint": "Seleziona prima una data per visualizzare gli orari disponibili.",
  "booking.your_data": "I Tuoi Dati",
  "booking.form_subtitle": "Compila il modulo per finalizzare il tuo appuntamento.",
  "booking.firstname": "Nome *",
  "booking.firstname_placeholder": "Nome",
  "booking.lastname": "Cognome *",
  "booking.lastname_placeholder": "Cognome",
  "booking.email": "Email *",
  "booking.email_placeholder": "tua@email.it",
  "booking.phone": "Telefono *",
  "booking.phone_placeholder": "+39 123 4567890",
  "booking.service_label": "Trattamento Desiderato *",
  "booking.service_placeholder": "Seleziona",
  "booking.service_combined": "Trattamento Combinato",
  "booking.service_consultation": "Consulenza",
  "booking.package_label": "Pacchetto Desiderato",
  "booking.package_undecided": "Ancora indeciso",
  "booking.package_essential": "Essential – da 1.490 €",
  "booking.package_premium": "Premium – da 3.990 €",
  "booking.package_luxe": "Luxe – da 7.490 €",
  "booking.package_exclusif": "Exclusif – Personalizzato",
  "booking.message_label": "Richieste Speciali o Note",
  "booking.message_placeholder": "Facci sapere a cosa dovremmo prestare particolare attenzione...",
  "booking.max_chars": "Max. 500 caratteri",
  "booking.privacy_consent": "Acconsento al trattamento dei miei dati per la prenotazione dell'appuntamento. Ho preso visione dell'informativa sulla privacy.",
  "booking.select_datetime_warning": "Seleziona data e ora per completare la prenotazione.",
  "booking.success_title": "Grazie per la tua prenotazione!",
  "booking.success_message": "Ti risponderemo entro 24 ore.",
  "booking.time_label": "Seleziona Orario",
  "booking.time_selected": "Selezionato:",
  "booking.time_unit": "ore",

  "footer.tagline": "Esteva Clinic – Dove la bellezza diventa arte.",
  "footer.services": "Servizi",
  "footer.about": "Chi Siamo",
  "footer.legal": "Legale",
  "footer.contact": "Contatti",
  "footer.hair": "Odontoiatria",
  "footer.dental": "Odontoiatria",
  "footer.surgery": "Chirurgia Plastica",
  "footer.botox": "Chirurgia Plastica",
  "footer.team": "Il Nostro Team",
  "footer.philosophy": "Filosofia",
  "footer.career": "Carriera",
  "footer.press": "Stampa",
  "footer.imprint": "Note Legali",
  "footer.privacy": "Privacy",
  "footer.terms": "Termini e Condizioni",
  "footer.faq": "FAQ",
  "footer.newsletter_title": "Rimani Ispirato.",
  "footer.newsletter_subtitle": "Approfondimenti esclusivi, nuovi trattamenti e offerte speciali direttamente nella tua casella di posta.",
  "footer.newsletter_placeholder": "Il tuo indirizzo email",
  "footer.newsletter_button": "Iscriviti",
  "footer.copyright": "© 2026 Esteva Clinic. Tutti i diritti riservati.",
  "footer.seo_text": "Esteva Clinic è la tua clinica di bellezza e odontoiatrica premium a Tirana, in Albania. Offriamo impianti dentali, corone in zirconio, faccette, trapianto di capelli (FUE), aumento del seno, rinoplastica, lifting, Botox, liposuzione e chirurgia plastica fino al 70% più economici rispetto a Svizzera, Germania e Austria. Pazienti da Zurigo, Basilea, Berna, Vienna, Monaco e Berlino si affidano a Esteva Clinic. Prima consulenza gratuita — prenota ora il tuo appuntamento.",

  "language.de": "DE",
  "language.it": "IT",
  "language.fr": "FR",
  "language.en": "EN",
  "language.sq": "SQ",

  "gallery.tag": "PRIMA &amp; DOPO",
  "gallery.heading_line1": "Risultati che",
  "gallery.heading_line2": "parlano da soli.",
  "gallery.subtitle": "Trasformazioni reali dei nostri clienti. Ogni immagine racconta una storia di rinnovata fiducia in sé stessi e bellezza naturale.",
  "gallery.filter_all": "Tutti",
  "gallery.filter_hair": "Odontoiatria",
  "gallery.filter_dental": "Odontoiatria",
  "gallery.filter_surgery": "Chirurgia Plastica",
  "gallery.before": "Prima",
  "gallery.after": "Dopo",
  "gallery.view_details": "Vedi Dettagli",
  "gallery.close": "Chiudi",
  "gallery.no_results": "Nessun risultato trovato in questa categoria.",
  "gallery.results_count": "{{count}} Risultati",
  "gallery.patient": "Paziente",
  "gallery.treatment": "Trattamento",
  "gallery.result_after": "Risultato dopo",
  "gallery.months": "mesi",
  "gallery.disclaimer": "I risultati mostrati sono esemplificativi. I risultati individuali possono variare.",

  "service_detail.how_it_works": "IL PROCESSO",
  "service_detail.benefits": "I VOSTRI VANTAGGI",
  "service_detail.faq": "DOMANDE FREQUENTI",
  "service_detail.process_title": "Il Processo",
  "service_detail.benefits_title": "I Vostri Vantaggi",
  "service_detail.faq_title": "Domande Frequenti",
  "service_detail.cta_heading": "Pronti per la Vostra Trasformazione?",
  "service_detail.cta_subtitle": "Prenotate ora la vostra consulenza personale senza impegno. Ci prendiamo tempo per voi.",
  "pricing.back_to_pricing": "Torna al Listino Prezzi",
  "pricing.view_details": "Dettagli",

  "team.tag": "IL NOSTRO TEAM",
  "team.heading_line1": "L'eccellenza ha bisogno",
  "team.heading_line2": "di volti.",
  "team.subtitle": "Scopri gli esperti che rendono Esteva Clinic la destinazione principale per i trattamenti estetici premium in Europa. Ogni membro del team è un maestro nel proprio campo.",
  "team.show_more": "Scopri di più",
  "team.show_less": "Mostra meno",
  "team.cta_heading": "Pronto per la tua trasformazione?",
  "team.cta_subtitle": "Il nostro team non vede l'ora di conoscerti e accompagnarti nel tuo percorso personale verso una nuova bellezza.",
  "team.cta_button": "Prenota subito una consulenza",
  "clinic.tag": "LA NOSTRA CLINICA",
  "clinic.heading_line1": "Spazi pensati",
  "clinic.heading_line2": "per il tuo benessere.",
  "clinic.subtitle": "Clinica moderna e attrezzatura all'avanguardia a Tirana. Dal comfort del lounge all'igiene del laboratorio dentale — ogni dettaglio per il tuo benessere.",
  "clinic.label_dental": "Laboratorio Dentale",
  "clinic.label_consultation": "Studio di Consultazione",
  "clinic.label_waiting": "Sala d'Attesa",
  "clinic.label_reception": "Area Reception",
  "clinic.dental_lab": "Laboratorio dentale moderno con attrezzatura di ultima generazione",
  "clinic.consultation": "Studio di consultazione confortevole per colloqui personali",
  "clinic.waiting": "Sala d'attesa spaziosa e accogliente",
  "clinic.reception": "Area reception moderna con design elegante",

  "process.tag": "IL TUO PERCORSO VERSO DI NOI",
  "process.heading": "Il tuo percorso medico, senza stress",
  "process.subtitle": "Ti guidiamo in ogni fase, garantendo un'esperienza sicura, confortevole e di successo presso Esteva Clinic.",
  "process.step1.title": "Consulenza",
  "process.step1.desc": "Comprendiamo le tue esigenze mediche, la tua storia clinica e le tue aspettative attraverso una consulenza iniziale online con i nostri specialisti.",
  "process.step2.title": "Piano Personalizzato",
  "process.step2.desc": "Creiamo un piano di trattamento su misura che include dettagli della procedura, tempistiche, costi e l'organizzazione completa del viaggio.",
  "process.step3.title": "Revisione Medica e Preparazione",
  "process.step3.desc": "Il nostro team analizza i tuoi referti medici e prepara ogni dettaglio in anticipo — inclusi documenti, viaggio e alloggio.",
  "process.step4.title": "Trattamento e Cura",
  "process.step4.desc": "Ricevi un trattamento di alta qualità presso Esteva Clinic con la massima attenzione e un'esperienza confortevole.",
  "process.step5.title": "Follow-up e Supporto",
  "process.step5.desc": "Restiamo al tuo fianco anche dopo il trattamento, offrendo supporto continuo e indicazioni per una guarigione ottimale.",
  "trust.heading_line1": "Trasformiamo la cura",
  "trust.heading_line2": "in un'esperienza di fiducia.",
  "trust.subtitle": "Affidati al team di Esteva Clinic per ricevere assistenza medica di alta qualità, trattamenti personalizzati e un supporto completo durante tutto il tuo percorso di cura.",
  "trust.check1": "Consulenze mediche specialistiche",
  "trust.check2": "Check-up e diagnostica avanzata",
  "trust.check3": "Chirurgia generale e specialistica",
  "trust.check4": "Trattamenti personalizzati per pazienti internazionali",
  "trust.check5": "Assistenza dedicata per il turismo medico",
  "trust.check6": "Supporto prima, durante e dopo il trattamento",

  "dental.tag": "ESPERTIZA DENTALE",
  "dental.heading": "Il tuo nuovo sorriso inizia qui",
  "dental.subtitle": "Soluzioni moderne per il tuo sorriso: impianti dentali, All-on-4 / All-on-6 / All-on-8 e smile design, con materiali di alta qualità e risultati naturali.",
  "dental.implant.title": "Impianti Dentali Premium",
  "dental.implant.desc": "Impianti dentali in titanio, resistenti e naturali, per ritrovare funzione ed estetica del sorriso a lungo termine.",
  "dental.crown.title": "Corona in Zirconio",
  "dental.crown.desc": "Corone in zirconio estetiche e resistenti, progettate per offrire un risultato naturale e duraturo.",
  "dental.veneer.title": "Faccette Dentali",
  "dental.veneer.desc": "Faccette estetiche sottili e naturali, ideali per correggere forma, colore e allineamento dei denti.",
  "dental.allon4.title": "All-on-4",
  "dental.allon4.desc": "Soluzione innovativa con 4 impianti dentali per arcata, che permette di ottenere denti fissi, stabili e naturali.",
  "dental.allon6.title": "All-on-6",
  "dental.allon6.desc": "Tecnica avanzata con 6 impianti dentali per arcata, che garantisce massima stabilità e funzionalità.",
  "dental.allon8.title": "All-on-8",
  "dental.allon8.desc": "Soluzione completa con 8 impianti dentali per arcata, ideale per garantire il massimo supporto e funzionalità al 100%.",
  "dental.pterygoid.title": "Impianti Pterigoidei",
  "dental.pterygoid.desc": "Tecnica avanzata che utilizza impianti pterigoidei per evitare innesti ossei, permettendo denti fissi anche in casi complessi con poco osso.",
  "dental.zygomatic.title": "Impianti Zigomatici",
  "dental.zygomatic.desc": "Soluzione avanzata che utilizza impianti zigomatici per pazienti con grave perdita ossea, evitando innesti e garantendo stabilità immediata e risultati duraturi.",
  "dental.maxillofacial.title": "Chirurgia Maxillo-Facciale",
  "dental.maxillofacial.desc": "Interventi specialistici per trattare problemi complessi di bocca, mascella e viso, con tecniche moderne e massima sicurezza.",
  "dental.cta": "Scopri di più",
  "overview.tag": "LE NOSTRE SPECIALITÀ",
  "overview.heading": "Tre Discipline. Un Solo Standard.",
  "overview.subtitle": "Odontoiatria, chirurgia plastica e trapianto di capelli — ogni specialità con specialisti di esperienza internazionale, tecnologia all'avanguardia e un obiettivo: la vostra bellezza naturale.",
  "overview.dental.title": "Odontoiatria",
  "overview.dental.desc": "Dai singoli impianti alla riabilitazione orale completa. Diagnostica 3D all'avanguardia, materiali di alta qualità e un team di implantologi esperti per il vostro nuovo sorriso.",
  "overview.dental.treatments": "Impianti, Corone in Zirconio, Faccette, All-on-4/6/8, Sbiancamento, Ortodonzia, Innesto Osseo, Sinus Lift, Impianti Pterigoidei e Zigomatici",
  "overview.surgery.title": "Chirurgia Plastica",
  "overview.surgery.desc": "Interventi estetici al massimo livello. Dalla rinoplastica al lifting facciale fino al rimodellamento corporeo — concetti individuali con massima sicurezza e risultati naturali.",
  "overview.surgery.treatments": "Rinoplastica, Lifting Facciale, Aumento e Riduzione del Seno, Blefaroplastica, Liposuzione, Addominoplastica, Lifting Braccia e Gambe, Palloncino Gastrico",
  "overview.hair.title": "Trapianto di Capelli",
  "overview.hair.desc": "Tecnica FUE a micropunzione più avanzata per un risultato naturalmente denso e senza cicatrici. Fino a 5.000 innesti in una seduta — con analisi capillare gratuita e piano di trattamento personalizzato.",
  "overview.hair.treatments": "Trapianto di Capelli FUE (fino a 5.000 innesti), Analisi Capillare Gratuita, Piano di Trattamento Personalizzato, Risultato Naturale Permanente",
  "overview.cta": "Tutti i Trattamenti e Prezzi",
  "implants.hero_title": "Impianti Dentali Premium in Albania",
  "implants.hero_subtitle": "Ritrova il piacere di sorridere, masticare e parlare con sicurezza grazie agli impianti dentali premium presso Esteva Clinic.",
  "implants.hero_desc": "Offriamo soluzioni implantari moderne, sicure e personalizzate per pazienti che cercano qualità, estetica e stabilità a lungo termine.",
  "implants.why_title": "Perché scegliere i nostri impianti dentali?",
  "implants.why_intro": "Gli impianti dentali sono una soluzione fissa e duratura per sostituire denti mancanti o gravemente compromessi. Presso Esteva Clinic, ogni caso viene studiato con attenzione per offrire un trattamento sicuro, estetico e funzionale.",
  "implants.benefit1_title": "Materiali premium",
  "implants.benefit1_desc": "Utilizziamo materiali selezionati per garantire resistenza, biocompatibilità e affidabilità nel tempo.",
  "implants.benefit2_title": "Piano personalizzato",
  "implants.benefit2_desc": "Ogni paziente riceve una valutazione individuale e un piano di trattamento creato in base alle sue esigenze.",
  "implants.benefit3_title": "Estetica naturale",
  "implants.benefit3_desc": "L'obiettivo è ottenere denti fissi, belli e naturali, in armonia con il sorriso del paziente.",
  "implants.when_title": "Quando sono indicati gli impianti dentali?",
  "implants.when_desc": "Gli impianti dentali sono indicati quando mancano uno o più denti, quando i denti naturali non sono più recuperabili o quando una protesi mobile non offre stabilità e comfort.",
  "implants.when_desc2": "Possono essere utilizzati per sostituire un singolo dente, più denti o un'intera arcata con soluzioni fisse come All-on-4, All-on-6 o Toronto Bridge.",
  "implants.path_title": "Il nostro percorso implantare",
  "implants.path_step1_title": "1. Valutazione",
  "implants.path_step1_desc": "Analisi del caso, visita specialistica e studio della situazione dentale.",
  "implants.path_step2_title": "2. Piano di cura",
  "implants.path_step2_desc": "Creazione di un piano personalizzato con tempi, materiali e costi chiari.",
  "implants.path_step3_title": "3. Inserimento impianti",
  "implants.path_step3_desc": "Procedura eseguita da un team medico esperto in ambiente sicuro e controllato.",
  "implants.path_step4_title": "4. Denti fissi",
  "implants.path_step4_desc": "Realizzazione della protesi finale per un sorriso stabile, funzionale ed estetico.",
  "implants.cta_title": "Richiedi una valutazione personalizzata",
  "implants.cta_desc": "Invia una panoramica dentale o contattaci per ricevere una prima valutazione. Il nostro team ti guiderà verso la soluzione più adatta al tuo caso.",
  "implants.cta_button": "Prenota un appuntamento",

  "imprint.title": "Note Legali",
  "imprint.responsible": "Responsabile del Contenuto",
  "imprint.address_label": "Indirizzo",
  "imprint.phone_label": "Telefono",
  "imprint.email_label": "Email",
  "imprint.authorized_label": "Rappresentanti Autorizzati",
  "imprint.register_label": "Registro delle Imprese",
  "imprint.vat_label": "Partita IVA",
  "imprint.disclaimer_title": "Esclusione di Responsabilità",
  "imprint.disclaimer_text": "I contenuti di questo sito web sono creati con la massima cura. Tuttavia, non possiamo garantire l'accuratezza, la completezza e l'attualità dei contenuti. Nonostante un attento controllo dei contenuti, non ci assumiamo alcuna responsabilità per i contenuti dei link esterni. I gestori delle pagine collegate sono gli unici responsabili del loro contenuto.",
  "imprint.copyright_title": "Diritto d'Autore",
  "imprint.copyright_text": "I contenuti e le opere creati dai gestori del sito su queste pagine sono soggetti alla legge sul diritto d'autore. La riproduzione, l'elaborazione, la distribuzione e qualsiasi tipo di utilizzo al di fuori dei limiti del diritto d'autore richiedono il consenso scritto del rispettivo autore o creatore.",
  "imprint.data_protection_link": "Informativa sulla Privacy",

  "booking.find_us": "DOVE SIAMO",
  "booking.visit_us": "Vieni a trovarci a Tirana",
  "booking.visit_subtitle": "La nostra clinica si trova nel cuore di Tirana. Prenota un appuntamento e vieni a conoscerci di persona.",

  "agb.title": "Condizioni Generali",
  "agb.meta_desc": "Condizioni Generali di Contratto della piattaforma di intermediazione Esteva.ch. Informazioni su ambito, responsabilità, servizi e legge applicabile.",

  "hero.discover_prices": "Scopri i prezzi",

  "services.hero_subtitle": "Tre discipline, un unico standard: la perfezione assoluta. Odontoiatria, chirurgia plastica e trapianto di capelli nel cuore di Tirana – fino al 70% in meno rispetto a DE/AT/CH.",
  "services.page_cta_title": "Pronti per la vostra trasformazione?",
  "services.page_cta_subtitle": "Prenotate ora la vostra consulenza personale a Tirana. Il nostro team di esperti creerà un concetto di trattamento su misura – perfettamente adattato alle vostre esigenze.",

  "testimonials.hero_subtitle": "Trasformazioni reali, emozioni reali. I nostri clienti vengono da tutta Europa a Tirana — e ripartono con una nuova sensazione di vita.",
  "testimonials.rating": "★ 4.9 / 5.0 — basato su oltre 240 recensioni verificate dei nostri clienti in tutta Europa.",
  "testimonials.cta_title": "Fate parte delle nostre storie di successo",
  "testimonials.cta_subtitle": "La vostra trasformazione inizia con una conversazione. Scopriamo insieme come possiamo esaltare la vostra bellezza naturale.",

  "about.vision_title": "Una visione nata sul Mediterraneo",
  "about.vision_para2": "Fondata dalla Dottoressa Nertila Basha, specialista di medicina estetica con formazione internazionale, Esteva Clinic unisce il meglio di due mondi: la precisione e il know-how della medicina d'eccellenza internazionale con la calda e autentica ospitalità balcanica. Il nostro team di 11 esperti — tra cui specialisti in chirurgia dei capelli, cosmetica dentale e medicina estetica — lavora in sinergia per ottenere il risultato ottimale per ogni cliente.",
  "about.meet_team_link": "Conoscere il nostro team",
  "about.albania_title": "Albania — un paese in ascesa",
  "about.albania_subtitle": "Tirana non è più un segreto. La capitale albanese si sta sviluppando rapidamente in uno dei centri economici e culturali più dinamici del Sud-Est Europa — e Esteva Clinic è nel mezzo di tutto questo.",
  "about.albania_card1_title": "Miracolo economico nei Balcani",
  "about.albania_card1_desc": "L'Albania registra una crescita record da anni. Investimenti internazionali, infrastrutture moderne e una popolazione giovane e altamente motivata rendono Tirana un hotspot per l'innovazione e il progresso.",
  "about.albania_card2_title": "Natura che entusiasma",
  "about.albania_card2_desc": "Dall'azzurro Adriatico a ovest alle maestose Alpi albanesi a nord — l'Albania unisce la leggerezza mediterranea alla grandiosità alpina nel più piccolo degli spazi.",
  "about.albania_card3_title": "Il nuovo magnete d'Europa",
  "about.albania_card3_desc": "Sempre più viaggiatori, nomadi digitali e aziende internazionali stanno scoprendo l'Albania. Tirana è stata nominata dal Time Magazine tra le città più entusiasmanti del mondo.",
  "about.experience_title": "Vivete Esteva Clinic in prima persona",
  "about.experience_subtitle": "Visitate noi a Tirana. O iniziate con una consulenza personale — di persona o online.",

  "booking.form_name_label": "Nome",
  "booking.form_name_placeholder": "Il tuo nome completo",
  "booking.form_phone_short": "Telefono",
  "booking.form_treatment_label": "Trattamento desiderato",
  "booking.form_message_optional": "Messaggio (opzionale)",
  "booking.form_select_please": "Seleziona",
  "booking.form_message_short_placeholder": "Il tuo messaggio per noi...",
  "booking.opening_hours_label": "Orari di Apertura",
  "booking.day_mofr": "Lun – Ven",
  "booking.day_saturday": "Sabato",
  "booking.day_sunday": "Domenica",
  "booking.day_closed": "Chiuso",
  "booking.albania_text": "Albania",

  "contact.hero_tag": "Siamo qui per voi",
  "contact.hero_title_line1": "Scriveteci.",
  "contact.hero_title_line2": "Rispondiamo entro 24h.",
  "contact.hero_subtitle": "Consulenza gratuita, richieste di preventivo o semplici domande — il team Esteva è felice di ricevere il vostro messaggio.",
  "contact.form_title": "Invia un messaggio",
  "contact.form_required_hint": "Tutti i campi con * sono obbligatori.",
  "contact.firstname_label": "Nome",
  "contact.lastname_label": "Cognome",
  "contact.phone_optional": "Telefono",
  "contact.subject_label": "Oggetto",
  "contact.subject_placeholder": "Seleziona...",
  "contact.subject_dental": "Odontoiatria & Impianti",
  "contact.subject_surgery": "Chirurgia Plastica",
  "contact.subject_hair": "Trapianto Capelli",
  "contact.subject_general": "Consulenza Generale",
  "contact.subject_price": "Richiesta Preventivo",
  "contact.subject_other": "Altro",
  "contact.message_label": "Il tuo messaggio",
  "contact.message_max": "(max. 500 caratteri)",
  "contact.privacy_contact": "Ho letto l'informativa sulla privacy e acconsento che i miei dati vengano utilizzati per elaborare la mia richiesta.",
  "contact.sending": "Invio in corso...",
  "contact.submit": "Invia messaggio",
  "contact.success_title": "Grazie!",
  "contact.success_message": "Il tuo messaggio è stato ricevuto. Ti risponderemo entro 24 ore.",
  "contact.new_message": "Invia un nuovo messaggio",
  "contact.info_title": "Informazioni di Contatto",
  "contact.follow_us": "Seguici",
  "contact.book_title": "Preferisci diretta?",
  "contact.book_online": "Prenota appuntamento online",
  "contact.book_free": "Consulenza gratuita",
  "contact.maps_open": "Apri in Google Maps",
  "contact.find_us_label": "DOVE SIAMO",
  "contact.opening_hours": "Orari di Apertura",
  "contact.address_label": "Indirizzo",
  "contact.monday_friday": "Lun – Ven",
  "contact.saturday": "Sabato",
  "contact.sunday": "Domenica",
  "contact.closed": "Chiuso",
  "instagram.followers": "Follower",
  "instagram.posts": "Post",
  "instagram.likes_label": "Mi piace",

  // ══════════════════════════════════════════
  // SEO Meta Tags – multilingual
  // ══════════════════════════════════════════
  "seo.ogLocale": "it_IT",
  "seo.home.title": "Esteva Clinic – Odontoiatria Premium & Chirurgia Plastica | Cosmetica Dentale & Chirurgia Estetica a Tirana",
  "seo.home.description": "Esteva Clinic a Tirana, Albania – La tua clinica premium per odontoiatria e chirurgia plastica. Impianti dentali, faccette, lifting viso, rinoplastica e altro. Team internazionale di esperti. Fino al 70% in meno rispetto a DE/AT/CH. Prenota ora una consulenza.",
  "seo.home.keywords": "Esteva Clinic, odontoiatria Tirana, chirurgia plastica Albania, impianti dentali, faccette, lifting viso, rinoplastica, aumento seno, turismo dentale, chirurgia estetica estero, medicina estetica Tirana",
  "seo.about.title": "Chi Siamo – Esteva Clinic | Clinica Premium di Bellezza a Tirana, Albania",
  "seo.about.description": "Esteva Clinic a Tirana, Albania: La nostra storia, filosofia e il nostro team internazionale di esperti. Scopri perché siamo l'indirizzo di riferimento per l'estetica premium nel cuore dei Balcani.",
  "seo.about.keywords": "Esteva Clinic Tirana, odontoiatria Albania, chirurgia plastica Tirana, medicina estetica Tirana, Dr. Nertila Basha, clinica premium Balcani, turismo dentale Albania",
  "seo.services.title": "Servizi – Esteva Clinic | Odontoiatria, Chirurgia & Trapianto Capelli a Tirana",
  "seo.services.description": "Servizi Esteva Clinic a Tirana: Odontoiatria premium con impianti dentali, faccette, corone in zirconio, chirurgia plastica e trapianto capelli FUE fino a 5.000 innesti. Fino al 70% in meno rispetto a DE/AT/CH.",
  "seo.services.keywords": "Odontoiatria Tirana, chirurgia plastica Albania, trapianto capelli Tirana, trapianto FUE, impianti dentali, lifting viso, rinoplastica, servizi Esteva Clinic",
  "seo.pricing.title": "Listino Prezzi Dentale, Chirurgia & Trapianto Capelli – Esteva Clinic Tirana | Costi Trasparenti",
  "seo.pricing.description": "Listino prezzi completo di Esteva Clinic Tirana: Impianti dentali da 350 €, rinoplastica da 2.200 €, trapianto capelli FUE da 1.500 €. Tutti i prezzi con hotel, taxi e scansione 3D inclusi.",
  "seo.pricing.keywords": "Prezzi Esteva Clinic, listino dentale Tirana, costo impianti dentali, prezzi chirurgia plastica Albania, costo trapianto capelli, trapianto FUE, costo rinoplastica, prezzo aumento seno",
  "seo.testimonials.title": "Recensioni – Esteva Clinic | Esperienze Reali dei Clienti da Tirana",
  "seo.testimonials.description": "Recensioni reali dei clienti Esteva Clinic: Odontoiatria e chirurgia plastica a Tirana. Leggi perché i nostri clienti vengono da tutta Europa – fino al 70% in meno.",
  "seo.testimonials.keywords": "Recensioni Esteva Clinic, esperienze odontoiatria, testimonianze chirurgia plastica, recensioni lifting viso, esperienze impianti dentali, testimonianze medicina estetica",
  "seo.booking.title": "Prenota Appuntamento – Esteva Clinic | Consulenza a Tirana",
  "seo.booking.description": "Prenota la tua consulenza personale presso Esteva Clinic a Tirana. Odontoiatria, chirurgia plastica e medicina estetica. Prima consulenza gratuita – fino al 70% in meno rispetto a DE/AT/CH.",
  "seo.booking.keywords": "Consulenza Tirana, prenotazione Esteva Clinic, appuntamento odontoiatria, consulenza chirurgia plastica, consulenza lifting viso, consulenza impianti dentali, prenotazione clinica bellezza",
  "seo.gallery.title": "Galleria – Esteva Clinic | Risultati Prima & Dopo da Tirana",
  "seo.gallery.description": "Impressionanti risultati prima e dopo di Esteva Clinic a Tirana: Impianti dentali, faccette, lifting viso, rinoplastica e altro. Risultati reali di clienti reali da tutta Europa.",
  "seo.gallery.keywords": "Galleria prima dopo, risultati odontoiatria, risultati faccette, trasformazioni lifting viso, risultati rinoplastica, Esteva Clinic, immagini medicina estetica",
  "seo.team.title": "Team – Esteva Clinic | Team Internazionale di Esperti a Tirana",
  "seo.team.description": "Conosci il team internazionale di esperti di Esteva Clinic a Tirana. Specialisti in odontoiatria, chirurgia plastica e medicina estetica. Multilingue, esperti, appassionati.",
  "seo.team.keywords": "Team Esteva Clinic, Esteva Clinic Tirana, chirurghi plastici Tirana, esperti odontoiatria Albania, specialisti dentali, medici chirurgia estetica",
  "seo.contact.title": "Contatti – Esteva Clinic | Richiedi una Consulenza a Tirana",
  "seo.contact.description": "Contatta Esteva Clinic a Tirana. Consulenza gratuita per odontoiatria, chirurgia plastica e trapianto capelli. Invia subito la tua richiesta!",
  "seo.contact.keywords": "Contatti Esteva Clinic, consulenza Tirana, richiesta odontoiatria, consulenza chirurgia Albania",
  "seo.imprint.title": "Note Legali – Esteva Clinic | Rruga Bylis, Tiranë 1001, Albania",
  "seo.imprint.description": "Note legali di Esteva Clinic Tirana. Informazioni legali, responsabili, indirizzo e recapiti di Esteva Clinic in Albania.",
  "seo.imprint.keywords": "Note legali, Esteva Clinic, Tirana, Albania, informazioni legali, contatti Esteva Clinic",
  "seo.dental_implants.title": "Impianti Dentali Premium – Esteva Clinic | Odontoiatria Tirana",
  "seo.dental_implants.description": "Impianti dentali premium a Tirana, Albania. Soluzioni implantari moderne, sicure e personalizzate. Fino al 70% in meno rispetto a DE/AT/CH. Richiedi ora una consulenza gratuita.",
  "seo.dental_implants.keywords": "Impianti dentali Tirana, impianti dentali Albania, costo impianti, All-on-4 Tirana, All-on-6 Albania, Esteva Clinic impianti",
  "seo.agb.keywords": "Termini, Esteva Clinic, condizioni, Esteva.ch",

  // ══════════════════════════════════════════
  // Informativa sulla Privacy
  // ══════════════════════════════════════════
  "privacy.title": "Informativa sulla Privacy",
  "privacy.subtitle": "Esteva.ch — Piattaforma di Intermediazione per Servizi Medici ed Estetici",
  "privacy.date": "Ultimo aggiornamento: 11 giugno 2026",
  "privacy.last_updated": "Ultimo aggiornamento",
  "privacy.s1_title": "1. Titolare del Trattamento",
  "privacy.s1_text": "Il titolare del trattamento dei dati su questa piattaforma è:\n\nAI Vision GmbH\nUnterdorf 8, 8222 Beringen, Svizzera\nEmail: info@esteva.ch\n(Intermediario / Gestore della Piattaforma)\n\nContitolare per il trattamento delle vostre richieste mediche:\nNertila Basha\nEuromed Dental Maxillofacial & Aesthetic Center\nRruga Bylis, Tiranë 1001, Albania\n\nLa presente informativa sulla privacy si applica in conformità con la Legge federale svizzera sulla protezione dei dati (LPD/nLPD) e, ove applicabile, con il Regolamento Generale sulla Protezione dei Dati dell'UE (GDPR).",
  "privacy.s2_title": "2. Quali Dati Raccogliamo",
  "privacy.s2_text": "Raccogliamo le seguenti categorie di dati personali:\n\n• Dati di contatto: nome, indirizzo email, numero di telefono\n• Richieste di trattamento e consulenze (fornite volontariamente)\n• Dati tecnici: indirizzo IP, tipo di browser, orario di visita, pagine visitate\n• Dati di comunicazione: messaggi tramite moduli di contatto o WhatsApp\n\nNon raccogliamo categorie particolari di dati personali (es. dati sanitari) senza il vostro consenso esplicito.",
  "privacy.s3_title": "3. Finalità del Trattamento",
  "privacy.s3_text": "I vostri dati sono utilizzati esclusivamente per le seguenti finalità:\n\n• Intermediazione verso il fornitore di servizi desiderato (clinica)\n• Risposta alle richieste e fissazione di appuntamenti\n• Miglioramento della piattaforma e gestione tecnica\n• Adempimento degli obblighi legali",
  "privacy.s4_title": "4. Condivisione dei Dati",
  "privacy.s4_text": "4.1 I vostri dati di contatto e la vostra richiesta di trattamento saranno inoltrati al fornitore di servizi da voi selezionato (clinica in Albania) affinché possa elaborare la vostra richiesta.\n\n4.2 Non condividiamo i vostri dati con terze parti per scopi commerciali.\n\n4.3 Il trasferimento dei dati all'estero (Albania) avviene sulla base del vostro consenso. L'Albania non è considerata un paese con un livello di protezione dei dati equivalente a quello svizzero; il trasferimento si basa sul vostro consenso esplicito ai sensi dell'Art. 17 nLPD.",
  "privacy.s5_title": "5. Cookie e Tracciamento",
  "privacy.s5_text": "5.1 La nostra piattaforma utilizza cookie tecnicamente necessari per il funzionamento del sito web.\n\n5.2 Possiamo utilizzare strumenti di analisi (es. Google Analytics). Potete opporvi all'uso dei cookie di analisi in qualsiasi momento.\n\n5.3 Potete disattivare i cookie nelle impostazioni del vostro browser; ciò potrebbe limitare la funzionalità della piattaforma.",
  "privacy.s6_title": "6. Periodo di Conservazione",
  "privacy.s6_text": "Conserviamo i vostri dati personali solo per il tempo necessario alle finalità indicate. I dati delle richieste saranno cancellati dopo un massimo di 2 anni.",
  "privacy.s7_title": "7. I Vostri Diritti",
  "privacy.s7_text": "Avete i seguenti diritti riguardo ai vostri dati personali:\n\n• Diritto di accesso: informazioni sui dati memorizzati\n• Diritto di rettifica: correzione di dati inesatti\n• Diritto alla cancellazione: cancellazione dei vostri dati salvo obblighi legali\n• Diritto di opposizione: opposizione al trattamento dei dati\n• Diritto alla portabilità dei dati: ricezione dei vostri dati in un formato comune\n\nPer esercitare i vostri diritti: info@esteva.ch\n\nI reclami possono essere presentati all'Incaricato Federale della Protezione dei Dati e della Trasparenza (IFPDT): www.edoeb.admin.ch",
  "privacy.s8_title": "8. Sicurezza dei Dati",
  "privacy.s8_text": "Adottiamo misure tecniche e organizzative adeguate per proteggere i vostri dati personali (es. crittografia SSL/TLS).",
  "privacy.s9_title": "9. Servizi di Terze Parti",
  "privacy.s9_text": "La piattaforma può utilizzare i seguenti servizi di terze parti:\n\n• Google Maps — Informativa sulla privacy: policies.google.com/privacy\n• WhatsApp Business — Informativa sulla privacy: www.whatsapp.com/legal/privacy-policy",
  "privacy.s10_title": "10. Modifiche alla Presente Informativa",
  "privacy.s10_text": "Ci riserviamo il diritto di modificare la presente informativa sulla privacy in qualsiasi momento. La versione attuale è disponibile su www.Esteva.ch.\n\nAI Vision GmbH | Unterdorf 8, 8222 Beringen | info@esteva.ch | www.Esteva.ch",

  // SEO
  "seo.privacy.title": "Informativa sulla Privacy – Esteva.ch | AI Vision GmbH, Beringen, Svizzera",
  "seo.privacy.description": "Informativa sulla privacy della piattaforma di intermediazione Esteva.ch. Informazioni sulla raccolta, il trattamento e la condivisione dei dati personali in conformità con la LPD/nLPD svizzera e il GDPR dell'UE. Titolare del trattamento: AI Vision GmbH, Beringen, Svizzera.",
  "seo.privacy.keywords": "Informativa privacy, Esteva.ch, AI Vision GmbH, protezione dati, LPD, nLPD, GDPR, dati personali, Beringen, Svizzera",

  // ══════════════════════════════════════════
  // Admin-Dashboard
  // ══════════════════════════════════════════
  "admin.logo": "ESTEVA ADMIN",
  "admin.to_website": "Vai al Sito",
  "admin.logout": "Esci",
  "admin.sidebar_expand": "Espandi sidebar",
  "admin.sidebar_collapse": "Comprimi sidebar",
  "admin.nav_dashboard": "Panoramica",
  "admin.nav_pages": "Pagine & Contenuti",
  "admin.nav_treatments": "Trattamenti & Prezzi",
  "admin.nav_team": "Team",
  "admin.nav_reviews": "Recensioni",
  "admin.nav_bookings": "Prenotazioni & Appuntamenti",
  "admin.nav_media": "Immagini & Media",
  "admin.nav_translations": "Lingue & Traduzioni",
  "admin.nav_footer": "Footer & Contatti",
  "admin.nav_seo": "SEO",
  "admin.nav_settings": "Impostazioni",
  "admin.breadcrumb_admin": "Admin",
  "admin.header_settings": "Impostazioni",

  "admin.dashboard_title": "Dashboard",
  "admin.dashboard_welcome": "Bentornato! Ecco il tuo riepilogo.",
  "admin.stat_bookings": "Prenotazioni",
  "admin.stat_bookings_sub": "{{count}} nuove",
  "admin.stat_confirmed": "Confermate",
  "admin.stat_confirmed_sub": "attive",
  "admin.stat_today": "Oggi",
  "admin.stat_today_sub": "Appuntamenti",
  "admin.stat_treatments": "Trattamenti",
  "admin.stat_treatments_sub": "Listini prezzi",
  "admin.stat_team": "Team",
  "admin.stat_team_sub": "Membri",
  "admin.stat_reviews": "Recensioni",
  "admin.stat_reviews_sub": "Testimonianze",

  "admin.upcoming_title": "Prossimi Appuntamenti",
  "admin.today_label": "Oggi",
  "admin.upcoming_label": "In arrivo",
  "admin.no_future_bookings": "Nessun altro appuntamento in programma.",
  "admin.view_all": "Vedi tutti",

  "admin.status_new": "Nuovo",
  "admin.status_confirmed": "Confermato",
  "admin.status_done": "Completato",

  "admin.activity_title": "Attività Recenti",
  "admin.activity_empty": "Nessuna attività ancora.",
  "admin.activity_just_now": "proprio ora",
  "admin.activity_min_ago": "{{count}} min fa",
  "admin.activity_hour_ago": "{{count}} ora fa",
  "admin.activity_day_ago": "{{count}} giorno fa",
  "admin.activity_days_ago": "{{count}} giorni fa",

  "admin.quick_title": "Accesso Rapido",
  "admin.quick_home": "Modifica Homepage",
  "admin.quick_bookings": "Gestisci Prenotazioni",
  "admin.quick_pricing": "Modifica Listino Prezzi",
  "admin.quick_team": "Gestisci Team",

  "admin.service_hair": "Trapianto Capelli",
  "admin.service_dental": "Cosmetica Dentale",
  "admin.service_botox": "Botox & Filler",
  "admin.service_combined": "Trattamento Combinato",
  "admin.service_consultation": "Consulenza",

  "team.nertila-basha.title": "CEO, Dentista, Implantologa & Protesista",
  "team.nertila-basha.specialty": "Impianti dentali & protesi estetica",
  "team.nertila-basha.bio": "La Dr.ssa Nertila Basha è CEO, dentista, implantologa e protesista con vasta esperienza nel settore dentale. Si distingue per la precisione clinica e la cura per i dettagli, offrendo trattamenti moderni e personalizzati per ogni paziente. Il suo obiettivo è garantire risultati funzionali ed estetici di massimo livello, con al centro sempre la salute e il benessere del paziente.",
  "team.nertila-basha.certifications": ["Specialista in Odontoiatria", "Implantologia & Protesi", "Università di Tirana"],

  "team.denisa-zhegu.title": "Medico di Medicina Estetica",
  "team.denisa-zhegu.specialty": "Trattamenti dermo-estetici",
  "team.denisa-zhegu.bio": "La Dr.ssa Denisa Zhegu è medico di medicina estetica con formazione internazionale, specializzata in trattamenti dermo-estetici avanzati. Si distingue per l'uso di tecniche moderne e sicure, offrendo risultati naturali e personalizzati per ogni paziente. Grazie alla sua esperienza e alla continua formazione, è un punto di riferimento nella medicina estetica di Tirana.",
  "team.denisa-zhegu.certifications": ["Specialista Medicina Estetica", "Certificazione Dermo-estetica", "Accademia Internazionale"],

  "team.nuri-qyra.title": "Anestesista & Intensivista",
  "team.nuri-qyra.specialty": "Anestesia & Sicurezza del Paziente",
  "team.nuri-qyra.bio": "Specialista con oltre 40 anni di esperienza in anestesia e terapia intensiva, dedito alla sicurezza, al monitoraggio e al massimo comfort del paziente durante ogni procedura medica e chirurgica. La sua calma e competenza trasmettono sicurezza a pazienti e team.",
  "team.nuri-qyra.certifications": ["Specialista in Anestesia", "Terapia Intensiva", "Università di Tirana"],

  "team.nurie-paloka.title": "Capo Sala Operatoria",
  "team.nurie-paloka.specialty": "Assistenza Chirurgica & Gestione Sala Operatoria",
  "team.nurie-paloka.bio": "Con 37 anni di esperienza nell'assistenza chirurgica e nella gestione della sala operatoria, è dedita al massimo livello di professionalità, organizzazione e cura del paziente durante ogni procedura medica. Coordina l'intero svolgimento dell'intervento con precisione e cuore.",
  "team.nurie-paloka.certifications": ["Capo Sala Operatoria", "Assistenza Chirurgica", "Gestione Clinica"],

  "team.ermir-mehillej.title": "Chirurgo Implantologo",
  "team.ermir-mehillej.specialty": "Implantologia dentale & Chirurgia",
  "team.ermir-mehillej.bio": "Il Dr. Ermir Mehillej è un dentista e implantologo chirurgico con 8 anni di esperienza nel settore. È specializzato in implantologia tradizionale, impianti pterigoidei e zigomatici, affrontando anche i casi più complessi con precisione e competenza. Grazie alla sua lunga esperienza offre soluzioni sicure, funzionali ed esteticamente avanzate per ogni paziente.",
  "team.ermir-mehillej.certifications": ["Specialista in Odontoiatria", "Chirurgia Implantologica", "Impianti Zigomatici & Pterigoidei"],

  "team.roel-ferataj.title": "Chirurgo Implantologo",
  "team.roel-ferataj.specialty": "Implantologia dentale & Chirurgia",
  "team.roel-ferataj.bio": "Il Dr. Roel Ferataj è un dentista e implantologo chirurgico con 4 anni di esperienza nel settore. È specializzato in implantologia tradizionale, impianti pterigoidei e zigomatici e si distingue per precisione e cura in ogni trattamento, anche nei casi più complessi. Con un approccio professionale e grande attenzione alle esigenze del paziente offre soluzioni moderne, sicure ed esteticamente armoniche.",
  "team.roel-ferataj.certifications": ["Specialista in Odontoiatria", "Chirurgia Implantologica", "Implantologia Avanzata"],

  "team.ana-bardhi.title": "Dentista specialista in Protesi & Endodonzia",
  "team.ana-bardhi.specialty": "Protesi, Endodonzia & Riabilitazione Estetica",
  "team.ana-bardhi.bio": "La Dr.ssa Ana Bardhi è una specialista in protesi dentale ed endodonzia con 6 anni di esperienza clinica. Si occupa della riabilitazione estetica e funzionale del sorriso, offrendo trattamenti personalizzati e soluzioni moderne per ogni paziente. Grazie alla sua professionalità e cura per i dettagli garantisce trattamenti di alta qualità in un ambiente accogliente e sicuro.",
  "team.ana-bardhi.certifications": ["Specialista in Protesi", "Specialista in Endodonzia", "Odontoiatria Estetica"],

  "team.rigers-xaka.title": "Assistente Dentale",
  "team.rigers-xaka.specialty": "Assistenza Clinica & Cura del Paziente",
  "team.rigers-xaka.bio": "Rigers Xaka è un assistente dentale con 2 anni di esperienza nel settore. Supporta il team medico durante le procedure cliniche e contribuisce a garantire un ambiente organizzato, sicuro e accogliente per i pazienti. Grazie alla sua professionalità e attenzione ai dettagli garantisce un'assistenza efficiente in ogni fase del trattamento.",
  "team.rigers-xaka.certifications": ["Assistente Dentale", "Supporto Clinico", "Gestione Pazienti"],

  "team.luciana-basha.title": "Endodontista",
  "team.luciana-basha.specialty": "Trattamento canalare & Conservazione dei denti naturali",
  "team.luciana-basha.bio": "Medico endodontista con 3 anni di esperienza nel trattamento canalare e nella conservazione dei denti naturali. Si dedica a trattamenti precisi, minimamente invasivi e senza dolore, utilizza tecniche moderne e pone sempre al primo posto il comfort e la salute del paziente.",
  "team.luciana-basha.certifications": ["Specialista in Endodonzia", "Specialista in Trattamento Canalare", "Università di Tirana"],

  "team.gezim-kabashi.title": "Autista & Assistenza Pazienti",
  "team.gezim-kabashi.specialty": "Supporto Organizzativo & Trasporto",
  "team.gezim-kabashi.bio": "Specializzato nell'assistenza completa ai pazienti durante tutto il loro soggiorno in Albania. Offre supporto organizzativo, comunicazione professionale e un'esperienza confortevole dal momento dell'arrivo fino alla fine del trattamento.",
  "team.gezim-kabashi.certifications": ["Assistenza Pazienti", "Autista", "Gestione Organizzativa"],

  "team.griselda.title": "Coordinatrice di Clinica",
  "team.griselda.specialty": "Gestione Clinica & Coordinamento Pazienti",
  "team.griselda.bio": "Griselda è la coordinatrice della clinica con oltre 10 anni di esperienza nella gestione e nel coordinamento di cliniche e strutture ospedaliere. Grazie alle sue capacità organizzative e all'attenzione verso i pazienti garantisce un percorso di trattamento efficiente, professionale e ben organizzato. È il punto di riferimento per l'assistenza e il supporto dei pazienti in tutte le fasi del trattamento.",
  "team.griselda.certifications": ["Gestione Clinica", "Coordinamento Pazienti", "Amministrazione Sanitaria"],
  "home.seo_service_areas_label": "Aree di servizio e trattamenti",
  "home.instagram_error": "Non è stato possibile caricare i post di Instagram.",
  "home.instagram_retry": "Riprova",
  "home.instagram_empty_title": "Ancora nessun post.",
  "home.instagram_empty_subtitle": "Seguici su Instagram per contenuti esclusivi.",
  "home.booking_reception_alt": "Reception Esteva Clinic",
  "home.newsletter_exists": "Questa email è già iscritta.",
  "home.newsletter_error": "Si è verificato un errore. Riprova.",
  "home.developed_by": "Sviluppato da",
  "svc.pricing_hero_tag": "Listino prezzi",
  "svc.savings_tag": "Confronto prezzi",
  "svc.savings_title": "Ecco quanto risparmi a confronto",
  "svc.savings_subtitle": "Stessa qualità, tecnologia all'avanguardia — a una frazione dei costi in Germania, Austria o Svizzera.",
  "svc.savings_col_treatment": "Trattamento",
  "svc.savings_col_savings": "Risparmio",
  "svc.packages_tag": "Pacchetti di trattamento",
  "svc.faq_heading": "Domande frequenti",
  "svc.pricing_cta_subtitle": "Non sei ancora sicuro di quale trattamento faccia per te? In un colloquio personale troveremo insieme la soluzione ideale.",
  "svc.pricing_faq1_q": "Cosa è incluso nei pacchetti di prezzo?",
  "svc.pricing_faq1_a": "Ogni pacchetto comprende i trattamenti indicati e il follow-up specificato. In un colloquio personale chiariamo tutti i dettagli e adattiamo il pacchetto esattamente alle tue esigenze individuali.",
  "svc.pricing_faq2_q": "Ci sono costi nascosti?",
  "svc.pricing_faq2_a": "No. Da Esteva Clinic la trasparenza viene al primo posto. Il prezzo concordato durante il colloquio è vincolante. Non ci sono costi aggiuntivi nascosti.",
  "svc.pricing_faq3_q": "Posso combinare i trattamenti?",
  "svc.pricing_faq3_a": "Certamente. Molti dei nostri clienti desiderano una combinazione di diversi trattamenti. Discutiamo volentieri le combinazioni individuali durante il colloquio.",
  "svc.pricing_faq4_q": "Quali metodi di pagamento accettate?",
  "svc.pricing_faq4_a": "Accettiamo carte di credito (Visa, Mastercard, American Express), bonifico bancario nonché pagamento rateale tramite il nostro partner. I dettagli li riceverai durante un colloquio personale.",
  "svc.pricing_faq5_q": "Quanto dura il follow-up?",
  "svc.pricing_faq5_a": "Il follow-up varia a seconda del trattamento. Tutti gli appuntamenti di follow-up si svolgono nella nostra clinica a Tirana. Un piano dettagliato viene redatto durante la tua consulenza.",
  "svc.price_from": "da ",
  "svc.price_fixed": "Prezzo fisso",
  "svc.view_details_link": "Vedi i dettagli",
  "svc.dental_subtitle": "Prezzi fissi trasparenti per tutti i trattamenti odontoiatrici — inclusa tecnologia all'avanguardia e specialisti esperti.",
  "svc.dental_cat_implants_label": "Impianti",
  "svc.dental_cat_crowns_label": "Corone e ponti",
  "svc.dental_cat_aesthetics_label": "Estetica e apparecchi ortodontici",
  "svc.dental_cat_bone_label": "Innesto osseo",
  "svc.dental_cat_prosthetics_label": "Protesi",
  "svc.dental_cat_implants_desc": "Impianti moderni in materiali di alta qualità per un morso saldo che dura tutta la vita.",
  "svc.dental_cat_crowns_desc": "Corone altamente estetiche in zirconio o ceramica — perfettamente abbinate al colore dei tuoi denti.",
  "svc.dental_cat_aesthetics_desc": "Il tuo sorriso più bello: dalla pulizia professionale all'apparecchio invisibile.",
  "svc.dental_cat_bone_desc": "Trattamenti preliminari necessari per un ancoraggio sicuro dell'impianto nella mascella.",
  "svc.dental_cat_prosthetics_desc": "Cura protesica flessibile e confortevole per una migliore qualità della vita.",
  "svc.surgery_subtitle": "Chirurgia plastica ed estetica ai massimi livelli — inclusa tutta l'assistenza pre e post-operatoria a Tirana.",
  "svc.surgery_cat_face_label": "Viso e lifting",
  "svc.surgery_cat_breast_label": "Chirurgia del seno",
  "svc.surgery_cat_body_label": "Rimodellamento del corpo",
  "svc.surgery_cat_special_label": "Procedure speciali",
  "svc.surgery_cat_face_desc": "La migliore chirurgia estetica per un profilo del viso armonioso e naturale.",
  "svc.surgery_cat_breast_desc": "Proporzioni naturalmente belle grazie a tecniche chirurgiche all'avanguardia e impianti Mentor.",
  "svc.surgery_cat_body_desc": "Contorni del corpo definiti: dalla liposuzione al rassodamento completo.",
  "svc.surgery_cat_special_desc": "Procedure speciali innovative per i tuoi desideri individuali.",
  "svc.hair_subtitle": "Tecnica FUE all'avanguardia con lame in zaffiro — capelli naturalmente folti, senza cicatrici e per tutta la vita.",
  "svc.hair_bestseller": "Più venduto",
  "svc.hair_treatment_label": "Trattamento",
  "svc.hair_total_price": "Prezzo totale",
  "svc.hair_all_inclusive": "Pacchetto all-inclusive",
  "svc.hair_graft_overview": "Pacchetti di innesti in sintesi",
  "svc.hair_popular": "Popolare",
  "svc.hair_ideal_for": "Ideale per:",
  "svc.hair_included_title": "Incluso nel pacchetto all-inclusive",
  "svc.hair_none_available": "Nessun trattamento di trapianto di capelli disponibile.",
  "svc.hair_tech_method_label": "Metodo",
  "svc.hair_tech_method_value": "FUE (Follicular Unit Extraction) — senza cicatrici",
  "svc.hair_tech_grafts_label": "Innesti",
  "svc.hair_tech_grafts_value": "Fino a 5.000 innesti in un'unica seduta",
  "svc.hair_tech_duration_label": "Durata",
  "svc.hair_tech_duration_value": "6–8 ore (un appuntamento)",
  "svc.hair_tech_anesthesia_label": "Anestesia",
  "svc.hair_tech_anesthesia_value": "Anestesia locale con sedazione",
  "svc.hair_tech_guarantee_label": "Garanzia",
  "svc.hair_tech_guarantee_value": "Risultato folto a vita",
  "svc.hair_tech_return_label": "Viaggio di ritorno",
  "svc.hair_tech_return_value": "Possibile dal 3° giorno dopo l'intervento",
  "svc.hair_incl_1": "Consulenza personale &amp; analisi dei capelli",
  "svc.hair_incl_2": "Esame del sangue &amp; controllo della salute",
  "svc.hair_incl_3": "Trattamento FUE con lame in zaffiro",
  "svc.hair_incl_4": "PRP (plasma ricco di piastrine) per favorire la guarigione",
  "svc.hair_incl_5": "Set speciale di shampoo per il post-trattamento",
  "svc.hair_incl_6": "Tutti i controlli di follow-up a Tirana",
  "svc.hair_graft1_count": "Fino a 2.000",
  "svc.hair_graft1_desc": "Piccoli diradamenti &amp; stempiature",
  "svc.hair_graft1_ideal": "Lieve caduta dei capelli",
  "svc.hair_graft2_desc": "Zona frontale &amp; chierica",
  "svc.hair_graft2_ideal": "Caduta dei capelli moderata",
  "svc.hair_graft3_desc": "Ripristino completo",
  "svc.hair_graft3_ideal": "Caduta dei capelli avanzata",
  "svc.detail_not_found": "Trattamento non trovato",
  "svc.detail_back_home": "Torna alla home page",
  "info.map_title": "Mappa della sede della Esteva Clinic",
  "info.hero_image_alt": "Prenotazione appuntamento Esteva Clinic",
  "legal.location_title": "Sede",
  "legal.notfound_seo_title": "Pagina non trovata – Esteva Clinic",
  "legal.notfound_seo_description": "La pagina richiesta non è stata trovata. Torna alla homepage di Esteva Clinic.",
  "legal.notfound_title": "Questa pagina non è stata trovata",
  "legal.notfound_subtitle": "La pagina che stai cercando non esiste.",
  "adm1.service_surgery": "Chirurgia",
  "adm1.saved": "Salvato!",
  "adm1.save_error": "Errore durante il salvataggio",
  "adm1.save_error_dot": "Errore durante il salvataggio.",
  "adm1.save": "Salva",
  "adm1.cancel": "Annulla",
  "adm1.delete": "Elimina",
  "adm1.refresh": "Aggiorna",
  "adm1.retry": "Riprova",
  "adm1.filter_all": "Tutti",
  "adm1.filter_visible": "Visibile",
  "adm1.filter_hidden": "Nascosto",
  "adm1.action_edit": "Modifica",
  "adm1.action_delete": "Elimina",
  "adm1.action_hide": "Nascondi",
  "adm1.action_show": "Mostra",
  "adm1.delete_irreversible": "Questa azione non può essere annullata.",
  "adm1.label_name": "Nome",
  "adm1.label_email": "E-mail",
  "adm1.label_phone": "Telefono",
  "adm1.label_package": "Pacchetto",
  "adm1.label_treatment": "Trattamento",
  "adm1.label_status": "Stato:",
  "adm1.label_location": "Località",
  "adm1.label_date": "Data",
  "adm1.label_rating": "Valutazione",
  "adm1.label_text": "Testo",
  "adm1.label_visible": "Visibile",
  "adm1.label_verified": "Verificato",
  "adm1.bookings_title": "Prenotazioni e appuntamenti",
  "adm1.bookings_summary": "{{total}} prenotazioni · {{new}} nuove · {{confirmed}} confermate · {{done}} completate",
  "adm1.bookings_load_error": "Errore durante il caricamento delle prenotazioni.",
  "adm1.bookings_status_error": "Impossibile aggiornare lo stato.",
  "adm1.bookings_saved_notified": "Salvato! Il cliente verrà avvisato.",
  "adm1.bookings_loading": "Caricamento delle prenotazioni...",
  "adm1.bookings_empty_title": "Nessuna prenotazione trovata.",
  "adm1.bookings_empty_desc": "Le nuove prenotazioni compaiono qui non appena i pazienti richiedono un appuntamento tramite il modulo del sito.",
  "adm1.reviews_title": "Recensioni",
  "adm1.reviews_summary": "{{total}} recensioni · {{visible}} visibili",
  "adm1.reviews_new": "Nuova recensione",
  "adm1.reviews_edit": "Modifica recensione",
  "adm1.reviews_empty_title": "Ancora nessuna recensione.",
  "adm1.reviews_empty_desc": "Fai clic su \"Nuova recensione\" per aggiungere la prima testimonianza del cliente.",
  "adm1.reviews_delete_confirm": "Eliminare la recensione?",
  "adm1.team_title": "Team",
  "adm1.team_count": "{{count}} membri del team",
  "adm1.team_new": "Nuovo membro",
  "adm1.team_edit": "Modifica membro",
  "adm1.team_delete_confirm": "Eliminare il membro?",
  "adm1.label_title_role": "Titolo / Ruolo",
  "adm1.ph_title_role": "es. CEO, dentista",
  "adm1.label_specialty": "Specializzazione",
  "adm1.ph_specialty": "es. impianti dentali",
  "adm1.label_bio": "Bio",
  "adm1.label_certifications": "Certificazioni (separate da virgole)",
  "adm1.ph_certifications": "es. specialista in odontoiatria, implantologia",
  "adm1.label_languages": "Lingue (separate da virgole, es. DE, EN, IT)",
  "adm1.label_photo": "Foto",
  "adm1.label_order": "Ordine (numero)",
  "adm1.treatments_title": "Trattamenti e prezzi",
  "adm1.treatments_summary": "{{count}} trattamenti · prezzi in €",
  "adm1.treatments_import": "Importa trattamenti predefiniti",
  "adm1.treatments_new": "Nuovo trattamento",
  "adm1.treatments_edit": "Modifica trattamento",
  "adm1.treatments_empty": "Nessun trattamento in questa categoria.",
  "adm1.treatments_delete_confirm": "Eliminare il trattamento?",
  "adm1.importing": "Importazione…",
  "adm1.import_error": "Errore di importazione",
  "adm1.col_treatment": "Trattamento",
  "adm1.col_category": "Categoria",
  "adm1.col_price_al": "Prezzo AL",
  "adm1.col_price_de": "Prezzo DE",
  "adm1.col_price_at": "Prezzo AT",
  "adm1.col_price_ch": "Prezzo CH",
  "adm1.col_savings": "Risparmio",
  "adm1.ph_treatment_name": "Nome del trattamento",
  "adm1.label_description": "Descrizione",
  "adm1.ph_description": "Descrizione...",
  "adm1.label_price_al": "Prezzo Albania (€)",
  "adm1.label_price_de": "Prezzo DE (€)",
  "adm1.label_price_at": "Prezzo AT (€)",
  "adm1.label_price_ch": "Prezzo CH (€)",
  "adm1.ph_price_range": "es. 1.500 – 2.000",
  "adm1.label_savings_percent": "Risparmio (%)",
  "adm1.settings_title": "Impostazioni",
  "adm1.settings_subtitle": "Gestisci le impostazioni globali del sito.",
  "adm1.settings_general": "Generale",
  "adm1.settings_colors": "Colori",
  "adm1.settings_change_password": "Cambia password",
  "adm1.settings_saved_live": "Salvato! Le modifiche sono subito online.",
  "adm1.label_website_name": "Nome del sito",
  "adm1.label_logo_url": "URL del logo",
  "adm1.label_favicon_url": "URL della favicon",
  "adm1.label_primary_color": "Colore primario",
  "adm1.label_accent_color": "Colore d'accento",
  "adm1.label_secondary_color": "Colore secondario",
  "adm1.ph_new_password": "Nuova password...",
  "adm1.pw_too_short": "La password deve contenere almeno 6 caratteri.",
  "adm1.pw_changed": "Password modificata con successo!",
  "adm1.footer_title": "Footer e contatti",
  "adm1.footer_subtitle": "Dati di contatto e impostazioni del footer del sito — esattamente come mostrati sulla pagina.",
  "adm1.footer_contact_data": "Dati di contatto",
  "adm1.footer_contact_data_desc": "Telefono, e-mail, indirizzo, orari di apertura — come nel footer e nella pagina dei contatti",
  "adm1.footer_social_desc": "Instagram e TikTok — esattamente come collegati nel footer e nella pagina dei contatti",
  "adm1.footer_tiktok_note": "Attualmente sul sito è collegato solo un segnaposto (#).",
  "adm1.footer_whatsapp_floating": "WhatsApp (pulsante flottante)",
  "adm1.label_whatsapp_number": "Numero (senza +, es. 41765593993)",
  "adm1.label_whatsapp_message": "Messaggio predefinito",
  "adm1.footer_texts": "Testi del footer",
  "adm1.footer_texts_desc": "Slogan e copyright — come nel footer del sito",
  "adm1.label_tagline": "Slogan (sotto il logo)",
  "adm1.label_copyright": "Riga del copyright",
  "adm1.label_address": "Indirizzo",
  "adm1.label_city_zip": "Città / CAP",
  "adm1.label_country": "Paese",
  "adm1.label_opening_hours": "Orario di apertura",
  "adm1.login_title": "Accesso admin",
  "adm1.login_subtitle": "Amministrazione Esteva Clinic",
  "adm1.login_failed": "Accesso non riuscito. E-mail o password errati.",
  "adm1.label_password": "Password",
  "adm1.ph_enter_password": "Inserisci la password",
  "adm1.pw_hide": "Nascondi password",
  "adm1.pw_show": "Mostra password",
  "adm1.login_loading": "Accesso in corso…",
  "adm1.login_submit": "Accedi",
  "adm2.saved": "Salvato!",
  "adm2.save_error": "Errore durante il salvataggio.",
  "adm2.save": "Salva",
  "adm2.cancel": "Annulla",
  "adm2.delete": "Elimina",
  "adm2.edit": "Modifica",
  "adm2.upload": "Carica",
  "adm2.reset": "Reimposta",
  "adm2.reset_all": "Reimposta tutto",
  "adm2.reset_lang": "Reimposta {{lang}}",
  "adm2.save_changes": "Salva modifiche",
  "adm2.saving": "Salvataggio...",
  "adm2.saved_short": "Salvato",
  "adm2.saved_live": "Salvato! Le modifiche sono online.",
  "adm2.remove": "Rimuovi",
  "adm2.changed": "Modificato",
  "adm2.optional": "opzionale",
  "adm2.preview": "Anteprima",
  "adm2.uploaded": "Caricato",
  "adm2.uploading": "Caricamento…",
  "adm2.uploading_progress": "Caricamento in corso...",
  "adm2.upload_failed": "Caricamento non riuscito.",
  "adm2.upload_failed_retry": "Caricamento non riuscito. Riprova.",
  "adm2.file_too_large": "File troppo grande (max 5 MB).",
  "adm2.file_too_large_compress": "File troppo grande (max 5 MB). Comprimilo.",
  "adm2.file_too_large_max": "Il file è troppo grande. Dimensione massima: 5 MB.",
  "adm2.max_5mb_jpg_png": "Max 5 MB, JPG o PNG",
  "adm2.only_jpg_png_webp": "Carica solo file JPG, PNG o WebP.",
  "adm2.only_image_files": "Seleziona solo file immagine (JPG, PNG, WebP).",
  "adm2.file_read_error": "Errore durante la lettura del file. Riprova.",
  "adm2.file_read_error_smaller": "Errore durante la lettura del file. Prova con un file più piccolo.",
  "adm2.no_image": "Nessuna immagine",
  "adm2.no_image_uploaded": "Nessuna immagine ancora caricata",
  "adm2.image_required": "Immagine richiesta",
  "adm2.edit_image": "Modifica immagine",
  "adm2.upload_image": "Carica immagine",
  "adm2.remove_image": "Rimuovi immagine",
  "adm2.image_url": "URL immagine",
  "adm2.image_url_optional": "URL immagine (opzionale)",
  "adm2.enter_image_url": "Oppure inserisci direttamente l'URL dell'immagine...",
  "adm2.image_upload_hint": "Carica un'immagine dal computer o incolla un URL. Le immagini caricate vengono salvate localmente.",
  "adm2.or_url": "oppure URL...",
  "adm2.enter_url": "oppure inserisci URL...",
  "adm2.location": "Posizione",
  "adm2.description": "Descrizione",
  "adm2.category": "Categoria",
  "adm2.filter_all": "Tutti",
  "adm2.media_title": "Immagini e media",
  "adm2.media_uploaded_count": "{{uploaded}} / {{total}} immagini caricate",
  "adm2.manage_images": "Gestisci immagini",
  "adm2.images": "Immagini",
  "adm2.images_count": "{{uploaded}} / {{total}} immagini",
  "adm2.customized": "Personalizzato",
  "adm2.no_images_category": "Nessuna immagine in questa categoria.",
  "adm2.reset_all_images": "Reimposta tutte le immagini",
  "adm2.gallery_comparisons": "Confronti della galleria",
  "adm2.gallery_before_after": "Galleria (Prima/Dopo)",
  "adm2.page_images": "Immagini delle pagine",
  "adm2.to_website": "Al sito web",
  "adm2.gallery_intro": "Gestisci le immagini di confronto prima/dopo per la pagina della galleria. Ogni voce è composta da un'immagine prima e una dopo.",
  "adm2.new_comparison": "Nuovo confronto",
  "adm2.no_gallery_images_category": "Nessuna immagine della galleria in questa categoria.",
  "adm2.before": "Prima",
  "adm2.after": "Dopo",
  "adm2.before_image": "Immagine prima",
  "adm2.after_image": "Immagine dopo",
  "adm2.no_label": "Senza etichetta",
  "adm2.months_count": "{{count}} mesi",
  "adm2.new_before_after": "Nuovo confronto prima/dopo",
  "adm2.edit_comparison": "Modifica confronto",
  "adm2.add_comparison": "Aggiungi confronto",
  "adm2.patient_label": "Etichetta paziente",
  "adm2.patient_label_ph": "es. Paziente 29K",
  "adm2.treatment_label": "Etichetta trattamento",
  "adm2.treatment_label_ph": "es. Estetica dentale",
  "adm2.result_after_months": "Risultato dopo (mesi)",
  "adm2.result_desc_ph": "Breve descrizione del risultato...",
  "adm2.cat_hero": "Hero e sfondi",
  "adm2.cat_services": "Servizi / Prestazioni",
  "adm2.cat_about": "Chi siamo / Clinica",
  "adm2.cat_pricing": "Prezzi / Pacchetti",
  "adm2.cat_gallery": "Galleria (Prima/Dopo)",
  "adm2.cat_team": "Team",
  "adm2.cat_instagram": "Instagram / Social",
  "adm2.gcat_dental": "Estetica dentale",
  "adm2.gcat_surgery": "Chirurgia",
  "adm2.gcat_hair": "Trapianto di capelli",
  "adm2.gcat_aesthetic": "Estetica",
  "adm2.img_home_hero_bg": "Home — Sfondo hero",
  "adm2.img_home_cta_bg": "Home — Sfondo CTA",
  "adm2.img_home_process": "Home — Sfondo processo",
  "adm2.img_home_trust": "Home — Sfondo fiducia",
  "adm2.img_about_hero": "Chi siamo — Hero (Tirana)",
  "adm2.img_services_hero": "Prestazioni — Hero",
  "adm2.img_pricing_hero": "Prezzi — Hero",
  "adm2.img_gallery_hero": "Galleria — Hero",
  "adm2.img_booking_hero": "Prenotazione — Hero",
  "adm2.img_hair": "Trapianto di capelli — Immagine",
  "adm2.img_dental": "Estetica dentale — Immagine",
  "adm2.img_botox": "Botox e filler — Immagine",
  "adm2.confirm_delete": "Eliminare davvero?",
  "adm2.no_subscribers": "Nessun iscritto disponibile.",
  "adm2.csv_email": "Email",
  "adm2.csv_language": "Lingua",
  "adm2.csv_status": "Stato",
  "adm2.csv_date": "Data",
  "adm2.col_email": "Email",
  "adm2.col_language": "Lingua",
  "adm2.col_status": "Stato",
  "adm2.col_date": "Data",
  "adm2.col_actions": "Azioni",
  "adm2.pages_content_title": "Pagine e contenuti",
  "adm2.pages_content_subtitle": "Modifica i contenuti di ogni pagina del sito web.",
  "adm2.language_label": "Lingua:",
  "adm2.editable_fields_count": "{{count}} campi modificabili",
  "adm2.editable_fields_count2": "{{count}} campi modificabili",
  "adm2.no_fields_configured": "Nessun campo configurato per questa pagina.",
  "adm2.pc_page_home": "Home",
  "adm2.pc_page_services": "Prestazioni",
  "adm2.pc_page_about": "Chi siamo",
  "adm2.pc_page_pricing": "Prezzi",
  "adm2.pc_page_gallery": "Galleria",
  "adm2.pc_page_team": "Team",
  "adm2.pc_page_booking": "Prenotazione",
  "adm2.pc_page_contact": "Contatti",
  "adm2.pc_hero_headline": "Titolo hero",
  "adm2.pc_hero_subline": "Sottotitolo hero",
  "adm2.pc_hero_button": "Pulsante hero",
  "adm2.pc_about_heading": "Intestazione Chi siamo",
  "adm2.pc_about_text": "Testo Chi siamo",
  "adm2.pc_services_heading": "Intestazione Prestazioni",
  "adm2.pc_pricing_heading": "Intestazione Prezzi",
  "adm2.pc_testimonials_heading": "Intestazione Recensioni",
  "adm2.pc_hair_title": "Titolo Trapianto di capelli",
  "adm2.pc_hair_desc": "Descrizione Trapianto di capelli",
  "adm2.pc_hair_heading": "Intestazione Trapianto di capelli",
  "adm2.pc_dental_title": "Titolo Estetica dentale",
  "adm2.pc_dental_desc": "Descrizione Estetica dentale",
  "adm2.pc_dental_heading": "Intestazione Estetica dentale",
  "adm2.pc_botox_title": "Titolo Botox e filler",
  "adm2.pc_botox_desc": "Descrizione Botox e filler",
  "adm2.pc_botox_heading": "Intestazione Botox e filler",
  "adm2.pc_story_title": "Titolo La nostra storia",
  "adm2.pc_story_text": "Testo La nostra storia",
  "adm2.pc_philosophy_title": "Titolo Filosofia",
  "adm2.pc_philosophy_text": "Testo Filosofia",
  "adm2.pc_form_heading": "Intestazione del modulo",
  "adm2.pc_ph_home_hero_title": "es. La tua clinica premium a Tirana",
  "adm2.pc_ph_home_hero_sub": "es. Trattamenti di alta qualità a prezzi equi...",
  "adm2.pc_ph_home_hero_cta": "es. Prenota subito un appuntamento",
  "adm2.pc_ph_about_title": "es. Informazioni su Esteva Clinic",
  "adm2.pc_ph_clinic_desc": "Descrizione della clinica...",
  "adm2.pc_ph_our_services": "es. I nostri servizi",
  "adm2.pc_ph_pricing_packages": "es. I nostri pacchetti di prezzo",
  "adm2.pc_ph_testimonials": "es. Cosa dicono i nostri clienti",
  "adm2.pc_ph_services_sub": "es. Scopri la nostra gamma completa di trattamenti...",
  "adm2.pc_ph_hair": "es. Trapianto di capelli",
  "adm2.pc_ph_dental": "es. Estetica dentale",
  "adm2.pc_ph_botox": "es. Botox e filler",
  "adm2.pc_ph_description": "Descrizione...",
  "adm2.pc_ph_about_sub": "es. La tua clinica premium nel cuore di Tirana...",
  "adm2.pc_ph_our_story": "es. La nostra storia",
  "adm2.pc_ph_clinic_story": "La storia della clinica...",
  "adm2.pc_ph_our_philosophy": "es. La nostra filosofia",
  "adm2.pc_ph_our_prices": "es. I nostri prezzi",
  "adm2.pc_ph_pricing_sub": "es. Prezzi trasparenti — fino al 70% in meno...",
  "adm2.pc_ph_gallery_title": "es. Galleria prima-dopo",
  "adm2.pc_ph_gallery_sub": "es. Risultati reali dei nostri trattamenti...",
  "adm2.pc_ph_our_team": "es. Il nostro team",
  "adm2.pc_ph_team_sub": "es. Conosci i nostri esperti...",
  "adm2.pc_ph_book_appt": "es. Prenota un appuntamento",
  "adm2.pc_ph_booking_sub": "es. Fissa ora il tuo appuntamento di consulenza...",
  "adm2.pc_ph_your_data": "es. I tuoi dati",
  "adm2.pc_ph_contact": "es. Contatti",
  "adm2.pc_ph_contact_sub": "es. Come raggiungerci...",
  "adm2.edit_page_title": "Modifica {{page}}",
  "adm2.manage_team_members": "Gestisci i membri del team",
  "adm2.edit_pricing_treatments": "Modifica i trattamenti del listino prezzi",
  "adm2.saved_de_synced": "Salvato! (DE → applicato automaticamente a tutte le lingue) Le modifiche sono ora online.",
  "adm2.saved_lang_live": "Salvato! ({{lang}}) Le modifiche sono ora online.",
  "adm2.changes_reset_for": "Tutte le modifiche per {{lang}} sono state reimpostate.",
  "adm2.lang_editor": "Editor lingua ({{lang}})",
  "adm2.lang_editor_de_note": "Stai modificando la versione DE. Le modifiche vengono applicate automaticamente a tutte le lingue (EN, IT, ES, FR).",
  "adm2.lang_editor_other_note": "Stai modificando la versione {{lang}}. Le modifiche vengono salvate separatamente per questa lingua.",
  "adm2.texts": "Testi",
  "adm2.key_label": "Chiave:",
  "adm2.changed_original": "Modificato — originale:",
  "adm2.no_editable_fields": "Nessun campo modificabile",
  "adm2.no_configured_fields": "Questa pagina non ha ancora campi configurati.",
  "adm2.read_only": "Sola lettura",
  "adm2.translations_info": "Le traduzioni vengono gestite direttamente nei file delle lingue. Questa pagina mostra i valori attuali a scopo di consultazione. Per le modifiche, contatta il tuo sviluppatore.",
  "adm2.pe_cat_dental": "Odontoiatria",
  "adm2.pe_cat_surgery": "Chirurgia plastica",
  "adm2.pe_cat_hair": "Trapianto di capelli",
  "adm2.pe_new_treatment": "Nuovo trattamento",
  "adm2.pe_default_stay": "Day hospital / 2 notti in hotel (3 giorni)",
  "adm2.pe_category_reset": "Tutti i trattamenti {{category}} per {{lang}} sono stati reimpostati.",
  "adm2.pe_confirm_reset_all": "Reimpostare davvero TUTTI i listini prezzi in TUTTE le lingue? Questa azione non può essere annullata.",
  "adm2.pe_all_reset": "Tutti i listini prezzi sono stati completamente reimpostati.",
  "adm2.pe_treatments_count": "{{count}} trattamento/i",
  "adm2.pe_edit_hint": "Modifica nome, prezzo e, facoltativamente, la durata del soggiorno.",
  "adm2.pe_saved_lang": "Salvato! ({{lang}})",
  "adm2.pe_treatment_name": "Nome del trattamento",
  "adm2.pe_price_eur": "Prezzo (€)",
  "adm2.pe_price_ph": "es. 350 – 400",
  "adm2.pe_stay": "Soggiorno",
  "adm2.pe_stay_ph": "es. Day hospital / 2 notti in hotel",
  "adm2.pe_no_treatments_lang": "Nessun trattamento in questa lingua",
  "adm2.pe_no_treatments_hint": "Aggiungi un nuovo trattamento o reimposta i dati predefiniti.",
  "adm2.pe_add_treatment": "Aggiungi trattamento",
  "adm2.pe_total_treatments": "Totale: {{count}} trattamenti in {{lang}}",
  "adm2.pe_short_dental": "Dentale",
  "adm2.pe_short_surgery": "Chirurgia",
  "adm2.pe_short_hair": "Capelli",
  "adm2.tm_lang_de": "Tedesco",
  "adm2.tm_lang_it": "Italiano",
  "adm2.tm_lang_en": "Inglese",
  "adm2.tm_lang_fr": "Francese",
  "adm2.tm_lang_es": "Spagnolo",
  "adm2.tm_lang_nl": "Olandese",
  "adm2.tm_lang_pl": "Polacco",
  "adm2.tm_lang_al": "Albanese",
  "adm2.tm_members_count": "Membri del team ({{count}})",
  "adm2.tm_add_member": "Aggiungi membro",
  "adm2.tm_no_members": "Ancora nessun membro del team.",
  "adm2.tm_add_first_member": "Aggiungi il primo membro",
  "adm2.tm_new_member": "Nuovo membro",
  "adm2.tm_edit_member": "Modifica membro",
  "adm2.tm_profile_image": "Immagine del profilo",
  "adm2.tm_upload_image_max": "Carica immagine (max 5 MB)",
  "adm2.tm_image_hint": "Si consiglia un'immagine quadrata. Max 5 MB.",
  "adm2.tm_name": "Nome",
  "adm2.tm_name_ph": "es. Nertila Basha",
  "adm2.tm_title_position": "Titolo / Posizione",
  "adm2.tm_title_ph": "es. CEO, Dentista",
  "adm2.tm_specialty": "Specialità",
  "adm2.tm_specialty_ph": "es. Impianti dentali e protesi estetica",
  "adm2.tm_bio": "Biografia",
  "adm2.tm_bio_ph": "Breve biografia del membro del team...",
  "adm2.tm_languages": "Lingue",
  "adm2.tm_certifications": "Certificati e qualifiche",
  "adm2.tm_cert_ph": "Certificato {{num}}",
  "adm2.tm_add_cert": "Aggiungi certificato",
  "shared.chat_title": "Assistente Esteva",
  "shared.chat_online": "Online",
  "shared.chat_restart": "Ricomincia",
  "shared.close": "Chiudi",
  "shared.book_appointment": "Prenota appuntamento",
  "shared.chat_input_placeholder": "Scrivi un messaggio...",
  "shared.send": "Invia",
  "shared.chat_close": "Chiudi la chat",
  "shared.chat_open": "Apri la chat",
  "shared.whatsapp_contact": "Contatto WhatsApp",
  "shared.whatsapp_tooltip": "Scrivici ora su WhatsApp",
  "shared.select_language": "Seleziona lingua",
  "shared.image": "Immagine",
  "shared.image_too_large": "File troppo grande (max. 10 MB).",
  "shared.image_upload_failed": "Caricamento non riuscito. Riprova.",
  "shared.image_uploading": "Caricamento…",
  "shared.image_select": "Seleziona immagine",
  "shared.image_url_placeholder": "oppure incolla un URL immagine…",
  "shared.open_menu": "Apri il menu",
};

export default common;